var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeads(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.38122 10.4217C5.30751 8.87133 3.8297 7.16596 3.02278 6.20722C2.773 5.91044 2.69115 5.69325 2.64194 5.31067C2.47343 4.00067 2.38918 3.34567 2.77329 2.92283C3.15742 2.5 3.8367 2.5 5.19528 2.5H14.8048C16.1633 2.5 16.8426 2.5 17.2267 2.92283C17.6108 3.34567 17.5266 4.00067 17.3581 5.31067C17.3088 5.69326 17.227 5.91045 16.9772 6.20722C16.1692 7.16718 14.6884 8.87558 12.6105 10.4279C12.4225 10.5684 12.2986 10.7972 12.2756 11.0512C12.0697 13.3267 11.8799 14.573 11.7618 15.2035C11.5711 16.2214 10.1277 16.8338 9.355 17.3802C8.89508 17.7055 8.33692 17.3183 8.27732 16.8148C8.16369 15.8551 7.94968 13.9053 7.71606 11.0512C7.69508 10.7949 7.57072 10.5634 7.38122 10.4217Z",
    stroke: "#2D3036",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeads);
export default __webpack_public_path__ + "static/media/leads.eba2a0a48cb1a2419ca4a8f621b91c65.svg";
export { ForwardRef as ReactComponent };